import React from "react";
import { useLocation } from "react-router-dom";
import AdminSidebar from "@/components/admin-dashboard/AdminSidebar";
import CohortSidebar from "@/components/admin-dashboard/CohortSidebar";
import AdminHeader from "@/components/admin-dashboard/AdminHeader";
import { useSidebarStore } from "@/store/sidebarStore";
import clsx from "clsx";

interface AdminLayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children, showSidebar = true }) => {
  const location = useLocation();
  const { isOpen } = useSidebarStore();

  // Check if we're on a cohort dashboard route
  const isCohortDashboardRoute =
    location.pathname.startsWith("/cohort-dashboard/");

  // Hide the top header bar on the main dashboard (no breadcrumbs needed)
  const isDashboardRoute = location.pathname === "/dashboard";

  const renderSidebar = () => {
    if (!showSidebar) return null;

    // If we're on a cohort dashboard route, show CohortSidebar
    if (isCohortDashboardRoute) {
      return <CohortSidebar />;
    }

    return <AdminSidebar />;
  };

  return (
    <div className="flex min-h-screen font-metropolis">
      {renderSidebar()}
      <div className={clsx(
        "flex-1 min-w-0 transition-all duration-300 ease-in-out bg-gray-color",
        !showSidebar && "ml-0",
        showSidebar && isCohortDashboardRoute && "lg:pl-[72px]",
        showSidebar && !isCohortDashboardRoute && isOpen && "lg:pl-[320px]",
        showSidebar && !isCohortDashboardRoute && !isOpen && "lg:pl-[80px]"
      )}>
        {!isDashboardRoute && <AdminHeader />}
        <main className="p-4 2xl:p-6 h-2md:pb-0">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
